import { exposeRequireContext } from 'live/expose'

export const exposeShared = () => {
    const req = require.context(
        '../shared',
        true,
        /^(?!.*__tests__.*)^(?!.*\.stories\.*)^(?!.*Spec.js)^(?!.*worker.js)^(?!.*__mocks__.*\.js)((.*\.([t|j]sx?\.*))[^.]*$)/
    )
    // this call expose recursively all the modules on the current folder
    exposeRequireContext(req, 'plugin-annotations/shared/')
}
